/**
 * Gestion des publications (ouverture en volet)
 */

(function ($, Drupal) {
    "use strict";

    $(function () {
        console.log("publication.js : dom is ready", $(".open_volet").length);
        var current_url = window.location.href;
       

        // Open the sidebar
        $(document).on("click", ".open_volet", function (e) {
            e.preventDefault();
            $(".volet").html(
                '<img class="loader" src="/themes/custom/foncsi/src/img/loader.gif" />'
            );
            var url = $(this).attr("href");
            $.get(url, function (data) {
                var publication_content = $("#content", data);
                $(".volet").html(publication_content);
                $(".volet").append('<div class="close_volet"></div>');
                window.history.pushState({}, "", url);
            });
            $(".volet").animate({ right: 0 });
            $(".volet-wrapper").addClass("show");
        });

        // Close the sidebar
        $(document).on("click", ".volet-wrapper", function () {
            var space_right = "-70%";
            if ($(window).width() < 991) space_right = "-105%";
            $(".volet-wrapper").removeClass("show");
            $(".volet").animate({ right: space_right });
            window.history.pushState({}, "", current_url);
        });
        $(".volet").on("click", ".close_volet", function () {
            var space_right = "-70%";
            if ($(window).width() < 991) space_right = "-105%";
            $(".volet-wrapper").removeClass("show");
            $(".volet").animate({ right: space_right });
            window.history.pushState({}, "", current_url);
        });


  
        $(document).on("click", ".view-bibliographie .views-row", function (e) {
        
            e.preventDefault();
        
            var url = $(this).find('.open_volet').attr("href");
        
            $.get(url, function (data) {
                var publication_content = $("#content", data);
                $(".volet").html(publication_content);
                $(".volet").append('<div class="close_volet"></div>');
                window.history.pushState({}, "", url);
            });
            $(".volet").animate({ right: 0 });
            $(".volet-wrapper").addClass("show");
        });

        $(document).on("click", ".view-publication-home .views-row", function (e) {
        
            e.preventDefault();
        
            var url = $(this).find('.open_volet').attr("href");
        
            $.get(url, function (data) {
                var publication_content = $("#content", data);
                $(".volet").html(publication_content);
                $(".volet").append('<div class="close_volet"></div>');
                window.history.pushState({}, "", url);
            });
            $(".volet").animate({ right: 0 });
            $(".volet-wrapper").addClass("show");
        });

        $(document).on("click", ".view-dernieres-parutions  .views-row", function (e) {
        
            e.preventDefault();
        
            var url = $(this).find('.open_volet').attr("href");
        
            $.get(url, function (data) {
                var publication_content = $("#content", data);
                $(".volet").html(publication_content);
                $(".volet").append('<div class="close_volet"></div>');
                window.history.pushState({}, "", url);
            });
            $(".volet").animate({ right: 0 });
            $(".volet-wrapper").addClass("show");
        });

        $(".view-actu-home .views-row").each(function(){
            var getActu = $(this);
            var url = getActu.find('h5 a').attr("href");
            getActu.wrap("<a href='" + url + "'></a>");
        })
        
           
        
        if ($(".last-publish").length > 0) {
            new Swiper(".view-dernieres-parutions .view-content", {
                speed: 600,
                spaceBetween: 10,
                slidesPerView: 1,
                breakpoints: {
                    910: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1100: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }

        var rating = $(".field--name-field-stars > .field__item").text();
        var stars = parseInt(rating);
        var starsHTML = $(".container-stars");
        if (rating !== "") {
            for (var i = 1; i <= 5; i++) {
                if (i <= stars) {
                    starsHTML.append(
                        '<img class="loader" src="/themes/custom/foncsi/src/img/star_color.svg" />'
                    );
                } else {
                    starsHTML.append(
                        '<img class="loader" src="/themes/custom/foncsi/src/img/star.svg" />'
                    );
                }
            }
        }

        if (rating === "") {
            $(".advice").css("display", "none");
        }

        var publication = $(".view-dernieres-parutions .views-row");
        var prev = $(".swiper-button-prev");
        var next = $(".swiper-button-next");
        let currentIndex = 0;

        publication.not(":first").addClass("inactive");
        publication.eq(0).addClass("active");

        publication.on("mouseenter", function () {
            if ($(this).index() !== 0) {
                publication.eq(0).removeClass("active").addClass("inactive");
            }
        });

        function updateDisplay() {
            $(publication).each(function (index, item) {
                if (index === currentIndex) {
                    $(item).addClass("active");
                    $(item).removeClass("inactive");
                } else {
                    $(item).removeClass("active");
                    $(item).addClass("inactive");
                }
            });
        }

        prev.on("click", function () {
            if (currentIndex > 0) {
                currentIndex--;
                updateDisplay();
            }
        });

        next.on("click", function () {
            if (currentIndex < publication.length - 1) {
                currentIndex++;
                updateDisplay();
            }
        });

        $.each(publication, function (i, item) {
            $(item).on("click", function () {
                currentIndex = i;
                updateDisplay();
            });
        });
        const linkTheme = $(".view-thematiques h5 a");

        linkTheme.each(function () {
            var link = $(this);

            if (link.length > 0) {
                var themeItem = link.closest(".view-thematiques .views-row");

                if (themeItem.length > 0) {
                    themeItem.wrap(
                        "<a href='" +
                            link.attr("href") +
                            "' class='swiper-slide explore'></a>"
                    );
                }
            }
        });

        $(".view-thematiques > .view-content").addClass("swiper-wrapper");
       
            if (window.innerWidth < 991) {
            if ($(".explore").length > 0) {
                new Swiper(".view-thematiques", {
                speed: 600,
                spaceBetween: 10,
                slidesPerView: 1.2,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                });
            }
            } else {
            
            }
       
        const linkActu = $(".view-actualite h5 a");

        linkActu.each(function () {
            var link = $(this);

            if (link.length > 0) {
                var actuItem = link.closest(".view-actualite .views-row");

                if (actuItem.length > 0) {
                    actuItem.wrap("<a href='" + link.attr("href") + "'></a>");
                }
            }
        });
        const linkActuHome = $(".view-actu-home h5 a");

        linkActuHome.each(function () {
            var link = $(this);

            if (link.length > 0) {
                var actuItem = link.closest(".view-actu-home .views-row");

                if (actuItem.length > 0) {
                    actuItem.wrap("<a href='" + link.attr("href") + "'></a>");
                }
            }
        });

        var openMenuMobile = $(
            "#block-foncsi-navigationprincipale > .menu > .menu-item > ul"
        );

        var linkMenu = $(
            "#block-foncsi-navigationprincipale > .menu > .menu-item > a"
        );

        linkMenu.each(function () {
            var link = $(this);
            var firstWord = link.text().split(" ")[0];
            var restOfText = link.text().substring(firstWord.length);
            var styledText =
                "<span class='uppercase'style='font-size: 22px; display: block;'>" +
                firstWord +
                "</span>" +
                restOfText;
            link.html(styledText);
        });

        var menuMobile = $(".hamburger-box");
        menuMobile.on("click", function () {
            $(".region-header").toggleClass("show");
			$(".header-wrapper").toggleClass("show");
            $(".hamburger-box").toggleClass("animation-bar");
            $(".region-primary-menu").toggleClass("show");
            $(".header-wrapper").toggleClass("height-menu");
            $("#block-foncsi-navigationprincipale > ul").toggleClass(
                "show-menu"
            );
            $(".region-header .links").toggleClass("show-links");
            openMenuMobile.removeClass("show");
            $(".header-wrapper").toggleClass("flex");
            $(".btn-mobile").toggleClass("show-links");
        });

        var langValue = $("html").attr("lang");
  
        if (langValue === "en-gb") {
            $(".region-header input").attr("placeholder", "Keywords...");
            $(".views-exposed-form .form-text").attr("placeholder", "Search with keywords...");
        } else {
            $(".region-header input").attr("placeholder", "Rechercher...");
        }

        var menuItem = $(
            "#block-foncsi-navigationprincipale > .menu > .menu-item--expanded"
        );

        menuItem.append('<span class="arrow"></span>');

        var spanMenu = $(".arrow");

        spanMenu.on("click", function () {
            $(this).closest(".menu-item").children(".menu").toggleClass("show");
        });

        var subMenus = $(".region-primary-menu .menu-item--expanded");

        subMenus.each(function () {
            var subMenu = $(this);
            var subMenuUl = subMenu.children("ul");

            function ajustWidthMenu() {
                var breakpoint = 991;
                var heightScreen = $(window).height();
               
                if (subMenuUl.height() > heightScreen && $(window).width() > breakpoint) {
                    subMenuUl.css("width", "500px");

                    subMenuUl.children("li").each(function () {
                        $(this).css("width", "50%");
                    });
                }
            }

            ajustWidthMenu();
        });
        var formPublication = $("#views-exposed-form-bibliographie-block-1");
        if (formPublication.length > 0) {
            $(".title-form").on("click", function () {
                formPublication.toggleClass("show-form");
            });
        }

        var thematique = $(".thematique_content");
        var body = $(".thematique_content .body-theme");
        var sidebar = $(".thematique_content .side-bar");
        sidebar.css("background-color", "#9da89f33");
		if ($(window).width() > 991) {
        	sidebar.css("height", body.outerHeight() + "px");
		}


        if (langValue === "en-gb") {
            $(".view-nos-collections a").each(function () {
                $(this).attr("href", function (i, href) {
                    return "/en" + href.replace("les-publications", "publications");
                });
            });
        } 

        if ($(".listing-publication h2").length > 0){
           var textInput =  $("#edit-theme option:selected").text();
           if (textInput !== "Toutes les thématiques" && textInput !== "All themes"){
                $(".listing-publication h2").text(textInput);
           }  
        }

        if ($(".last-publication .pager__item a")){
            $(".last-publication .pager__item a").each(function () {

                var currentUrl;

                if(langValue === "en-gb"){
                    currentUrl = "/en/publications/"+ $(this).attr("href")
                }else{
                    currentUrl = "/les-publications/"+ $(this).attr("href")
                }
               
                $(this).attr("href", currentUrl);
                
            });
        }

        $(".language").each(function() {
            $(this).find("a").last().addClass("hide-after");
        });

    });
})(jQuery, Drupal);
